<template>
  <div class="row">
    <div class="col">
      <div class="card bg-white">
        <div class="card-header bg-gray-100">
          <p class="text-semibold no-margin">
            Parâmetro Sistema
          </p>
          <div class="heading-elements">
            <i class="fas fa-long-arrow-alt-left position-left" @click="voltar()" style="cursor: pointer"></i>
          </div>
        </div>

        <div class="box-body">
					<div v-show="errorMessage != ''" class="alert alert-danger">{{ errorMessage }}</div>

          <div class="row">
            <div class="form-group col-12 col-md-6">
              <label for="cd_parametro">Código <sup class="text-danger">* </sup></label>
              <input id="cd_parametro" v-model="registro.cd_parametro" type="text" class="form-control" v-bind:class="{ 'box-input-required': errors.cd_parametro }">
              <span v-show="errors.cd_parametro != null" class="help-inline">{{ errors.cd_parametro }}</span>
            </div>
            <div class="form-group col-12 col-md-6">
              <label for="valor">Valor <sup class="text-danger">* </sup></label>
              <input id="valor" v-model="registro.valor" type="text" class="form-control" v-bind:class="{ 'box-input-required': errors.valor }">
              <span v-show="errors.valor != null" class="help-inline">{{ errors.valor }}</span>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-12 col-md-6">
              <label for="idc_status">Status <sup class="text-danger">* </sup></label>
              <select id="idc_status" v-model="registro.idc_status" style="width: auto" class="form-control" v-bind:class="{ 'box-input-required': errors.idc_status }">
                <option value="1">Ativo</option>
                <option value="2">Inativo</option>
              </select>
              <span v-show="errors.idc_status != null" class="help-inline">{{ errors.idc_status }}</span>
            </div>
            <div class="form-group col-12 col-md-6">
              <label for="descricao">Descrição <sup class="text-danger">* </sup></label>
              <input id="descricao" v-model="registro.descricao" type="text" class="form-control" v-bind:class="{ 'box-input-required': errors.descricao }">
              <span v-show="errors.descricao != null" class="help-inline">{{ errors.descricao }}</span>
            </div>
          </div>
        </div>

        <div class="box-footer text-center">
          <div class="btn-group">
            <button type="button" id="cancelButton" class="btn btn-warning" @click="voltar()">Cancelar</button>
            <button type="button" id="gravarButton" class="btn btn-success" @click="gravar()">Gravar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ParametrosSistemaActions from '../../actions/ParametrosSistemaActions'

export default {
  name: 'novo',
  data () {
    return {
      errorMessage: '',
      errors: {},
      hasError: false,
      registro: {
        cd_parametro: '',
        valor: '',
        descricao: '',
        idc_status: ''
      }
    }
  },
  mounted () {
    this.$parent.$parent.$data.description = 'Novo'
  },
  methods: {
    voltar () {
      this.$router.push('/parametros')
    },
    validation () {
      this.errors = {}
      this.hasError = false

      if (!this.registro.cd_parametro) {
        this.errors.cd_parametro = 'Este campo deve ser preenchido.'
        this.hasError = true
      }

      if (!this.registro.valor) {
        this.errors.valor = 'Este campo deve ser preenchido.'
        this.hasError = true
      }

      if (!this.registro.descricao) {
        this.errors.descricao = 'Este campo deve ser preenchido.'
        this.hasError = true
      }

      if (!this.registro.idc_status) {
        this.errors.idc_status = 'Este campo deve ser preenchido.'
        this.hasError = true
      }
    },
    gravar () {
      this.validation()

      if (!this.hasError) {
        this.$parent.$parent.$data.showModalLoader = true

        ParametrosSistemaActions.cadastrarParametro({
          cd_parametro: this.registro.cd_parametro,
          valor: this.registro.valor,
          descricao: this.registro.descricao,
          idc_status: this.registro.idc_status
        })
        .then(response => {
          this.$parent.$parent.$data.showModalLoader = false
          this.$router.push('/parametros')
        })
        .catch((error) => {
          console.log(error.message)
          this.errorMessage = 'Ocorreu um erro ao gravar o registro.'
          this.$parent.$parent.$data.showModalLoader = false
        })
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/parametros/Novo.vue